/** @jsx jsx */
import React from "react";
import { jsx, Box } from "theme-ui";
import { BgImage } from "gbimage-bridge";

const ThemeContainer = ({ children, backgroundColor,backgroundImage,backgroundImageClass,  textColor, ...props }) => (
  <BgImage image={backgroundImage?.gatsbyImageData} sx={{ marginInline: "auto" }} className={backgroundImageClass}>
    <Box {...props} backgroundColor={backgroundColor} color={textColor}>
      {children}
    </Box>
  </BgImage>
  );


export default ThemeContainer;
